import { render, staticRenderFns } from "./NotificationChannelCheck.vue?vue&type=template&id=7fddd948&"
import script from "./NotificationChannelCheck.vue?vue&type=script&lang=js&"
export * from "./NotificationChannelCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports